import React from 'react';
import { useLogout } from 'ducks/user';
import { getNavigationItems, MenuItemType } from 'layouts/AppPageTemplate/utils/menus';
import { usePermissions } from 'utils/permissions';
import { useUserContext } from 'common/contexts/UserContext';
import { MenuItem } from './MenuItem';
import { MenuDropdown } from './MenuDropdown';
import { SettingsMenu } from './SettingsMenu';

import fonts from '../../../../styles/typography.module.css';

interface Props {
  handleMenuOpen: () => void;
}

export const MobileMenu: React.FC<Props> = ({ handleMenuOpen }) => {
  const permissions = usePermissions();
  const { user } = useUserContext();
  const handleLogout = useLogout();

  const items = getNavigationItems(permissions, user);

  const mappedItems = items.map((item: MenuItemType): React.ReactNode => {
    switch (item.type) {
      case 'flat':
        return <MenuItem page={item.page} key={item.page.title} onMenuOpen={handleMenuOpen} />;
      case 'nested':
        return <MenuDropdown dropdown={item} key={item.title} onMenuOpen={handleMenuOpen} />;
      default:
        return null;
    }
  });

  return (
    <div className={fonts.font}>
      <div className="h-screen w-full bg-blue-900 p-8">
        <ul className="flex flex-col space-y-8">
          {mappedItems}
          <SettingsMenu onMenuOpen={handleMenuOpen} />
          <div className="w-full flex justify-between items-center py-1 px-4 rounded-md text-blue-300 font-semibold hover:bg-darkblue-900">
            <h2 onClick={handleLogout}>Log Out</h2>
          </div>
        </ul>
      </div>
    </div>
  );
};
MobileMenu.displayName = 'MobileMenu';
